import { Component, OnInit } from '@angular/core';
import {TooltipBaseComponent} from '../tooltip-base/tooltip-base.component';

@Component({
  selector: 'app-tooltip-metrics',
  templateUrl: './tooltip-metrics.component.html',
  styleUrls: ['./tooltip-metrics.component.scss']
})
export class TooltipMetricsComponent extends TooltipBaseComponent implements OnInit {

  ngOnInit(): void {
  }

}
